var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "list-container" },
    [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "table-wrapper" },
        [
          _vm.tableData.length > 0
            ? _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading,
                      expression: "loading"
                    }
                  ],
                  ref: "multipleTable",
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.tableData,
                    "max-height": "800",
                    "default-sort": { prop: "id", order: "descending" }
                  }
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "id",
                      label: "赔付单ID",
                      sortable: "",
                      width: "120",
                      align: "center"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "type",
                      label: "赔付原因",
                      width: "120",
                      align: "center"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    scope.row.type_text ||
                                      (scope.row.type === "1"
                                        ? "货期超时"
                                        : "缺货断货")
                                  ) +
                                  "\n        "
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      2842652609
                    )
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "status",
                      label: "处理状态",
                      width: "120",
                      align: "center"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    scope.row.status_text ||
                                      {
                                        "1": "待赔付",
                                        "2": "已完成",
                                        "3": "已作废"
                                      }[scope.row.status]
                                  ) +
                                  "\n        "
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      924841253
                    )
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "created_at",
                      label: "赔付单生成时间",
                      width: "180",
                      align: "center"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "complete_datetime",
                      label: "赔付单完成时间",
                      "min-width": "180",
                      align: "center"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "supply_name",
                      label: "供应商(商家)",
                      "min-width": "150",
                      align: "center"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "supply_id",
                      label: "商家ID",
                      "min-width": "120",
                      align: "center"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "kh_num",
                      label: "款数",
                      width: "120",
                      align: "center"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "total_num",
                      label: "件数",
                      width: "120",
                      align: "center"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "total_slow_compensation_price",
                      label: "赔付金额",
                      width: "120",
                      align: "center"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    scope.row.total_slow_compensation_price
                                      ? "¥" +
                                          scope.row
                                            .total_slow_compensation_price
                                      : "-"
                                  ) +
                                  "\n        "
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      2642203410
                    )
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      fixed: "right",
                      label: "操作",
                      width: "120",
                      align: "center"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "text", size: "small" },
                                  on: {
                                    click: function($event) {
                                      return _vm.handleDetail(scope.row)
                                    }
                                  }
                                },
                                [_vm._v("\n            查看详情\n          ")]
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      1954158379
                    )
                  })
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.data
        ? _c(
            "div",
            { staticClass: "pagination" },
            [
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.currentPage,
                  "page-size": _vm.pageSize,
                  total: _vm.total,
                  "page-sizes": [10, 20, 50, 100],
                  layout: "total, sizes, prev, pager, next, jumper"
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: { title: "操作日志", visible: _vm.logVisible },
          on: {
            "update:visible": function($event) {
              _vm.logVisible = $event
            }
          }
        },
        [
          _c(
            "el-table",
            { attrs: { data: _vm.logData } },
            [
              _c("el-table-column", {
                attrs: { property: "admin", label: "操作人", align: "center" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  property: "operate_mode",
                  label: "操作方式",
                  align: "center"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  property: "operate_result",
                  label: "操作结果",
                  align: "center"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  property: "created_at",
                  label: "操作时间",
                  align: "center"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { property: "remark", label: "备注", align: "center" }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "notice" }, [
      _c("div", [
        _vm._v(
          "\n      ●\n      每天早上8点统计商家因货期超期、主动断计划所产生的应赔付信息，并生成赔付单。\n    "
        )
      ]),
      _vm._v(" "),
      _c("div", [
        _vm._v(
          '\n      ●\n      每天早上10点，系统执行赔付脚本，将所有前一天生成的且状态为"待赔付"的赔付单执行资金划扣。\n    '
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-77315d9d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-77315d9d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/merchantClaimsOrder/components/CompensationList.vue
// module id = null
// module chunks = 